import { Brain, FileText, Layout, PenTool } from 'lucide-react';
import { ScrollAnimation } from '@/components/ui/scroll-animation';

const features = [
  {
    icon: Brain,
    title: 'AI-Powered Analysis',
    description: 'Advanced algorithms extract key concepts and generate comprehensive study materials automatically.',
  },
  {
    icon: Layout,
    title: 'Smart Organization',
    description: 'Automatically organized chapters and topics for efficient learning and quick reference.',
  },
  {
    icon: FileText,
    title: 'Quiz Generation',
    description: 'Auto-generated quizzes and practice tests to reinforce your understanding.',
  },
  {
    icon: PenTool,
    title: 'Visual Learning',
    description: 'Beautiful mind maps and visual aids to help you grasp complex concepts.',
  },
];

const getAnimation = (index: number) => {
  // Alternate between slide-left and slide-right for desktop
  if (index % 2 === 0) {
    return 'slide-left';
  }
  return 'slide-right';
};

export function Features() {
  return (
    <section className="py-24 transition-colors duration-300 dark:bg-dark-bg">
      <div className="container mx-auto px-4">
        <ScrollAnimation 
          animation="fade-up" 
          duration={0.9}
          className="text-center"
        >
          <h2 className="text-3xl font-bold text-gray-900 dark:text-dark-text sm:text-4xl">
            Powerful Features for Better Learning
          </h2>
          <p className="mt-4 text-lg text-gray-600 dark:text-dark-muted">
            Everything you need to transform video content into effective study materials
          </p>
        </ScrollAnimation>

        <div className="mt-16 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {features.map((feature, index) => (
            <ScrollAnimation
              key={feature.title}
              animation={getAnimation(index)}
              delay={index * 0.2} // Increased delay for more pronounced stagger
              duration={0.9} // Increased duration
              className="group rounded-xl bg-white p-6 shadow-mercury transition-all duration-300 hover:shadow-mercury-elevated dark:bg-dark-card dark:shadow-mercury-dark dark:hover:shadow-mercury-dark-hover"
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-50 text-primary-500 transition-colors duration-300 group-hover:bg-primary-100 dark:bg-primary-900/10 dark:text-primary-400 dark:group-hover:bg-primary-900/20">
                <feature.icon className="h-6 w-6" />
              </div>
              <h3 className="mt-4 text-lg font-semibold text-gray-900 dark:text-dark-text">
                {feature.title}
              </h3>
              <p className="mt-2 text-gray-600 dark:text-dark-muted">
                {feature.description}
              </p>
            </ScrollAnimation>
          ))}
        </div>
      </div>
    </section>
  );
}